const E={LEFT:"ArrowLeft",RIGHT:"ArrowRight",UP:"ArrowUp",DOWN:"ArrowDown",ESCAPE:"Escape",ENTER:"Enter",SPACE:" ",TAB:"Tab",HOME:"Home",END:"End"};export{E as KEY_CONSTANTS};
